import React from 'react';

interface XuanYuanReportFooterProps {
  qrDataUrl?: string | null;
  siteLabel?: string;
  className?: string;
  textClassName?: string;
  emphasizeClassName?: string;
  qrBorderClassName?: string;
  leftAction?: React.ReactNode;
}

const XuanYuanReportFooter: React.FC<XuanYuanReportFooterProps> = ({
  qrDataUrl,
  siteLabel = 'qimen.aifashou.cn',
  className = '',
  textClassName = 'text-gray-600',
  emphasizeClassName = 'text-gray-800',
  qrBorderClassName = 'border-gray-200',
  leftAction,
}) => (
  <div className={`flex items-end justify-between gap-4 ${leftAction ? 'mt-2 pt-2' : 'mt-7 pt-4 border-t border-slate-200'} ${className}`.trim()}>
    <div className={`text-xs leading-5 ${textClassName}`.trim()}>
      <div>本报告由轩辕国学生成，仅供娱乐。</div>
      <div className={`font-semibold ${emphasizeClassName}`.trim()}>
        扫码免费测试 · {siteLabel}
      </div>
    </div>
    {leftAction ? <div className="shrink-0">{leftAction}</div> : null}
    <div className="text-center shrink-0">
      <div className={`w-20 h-20 bg-white border rounded-lg p-1.5 shadow-sm flex items-center justify-center ${qrBorderClassName}`.trim()}>
        {qrDataUrl ? (
          <img src={qrDataUrl} alt="扫码免费测试二维码" className="w-full h-full object-contain" />
        ) : (
          <div className="w-8 h-8 bg-slate-100 rounded animate-pulse" />
        )}
      </div>
      <div className="text-[10px] text-slate-500 mt-1">扫码免费测试</div>
    </div>
  </div>
);

export default XuanYuanReportFooter;
